import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ActionButtonProps {
    text: string;
    onClick: () => void;
    icon?: IconDefinition;
    className?: string;
    iconPosition?: 'left' | 'right';
    fontSize?: 'small' | 'medium' | 'large' | 'xlarge';
    includeAnimation?: boolean;
    buttonRef?: React.RefObject<HTMLButtonElement>;
}

const ActionButton: React.FC<ActionButtonProps> = ({
    text,
    onClick,
    icon,
    className = '',
    iconPosition = 'right',
    fontSize = 'medium',
    includeAnimation = false,
    buttonRef,
}) => {
    return (
        <button
            className={`action-button ${className}`}
            onClick={onClick}
            ref={buttonRef}
        >
            {iconPosition === 'left' && icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={`icon ${iconPosition} ${fontSize} ${
                        includeAnimation ? 'animated' : ''
                    }`}
                />
            )}
            <p className={`text ${fontSize}`}>{text}</p>
            {iconPosition === 'right' && icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={`icon ${iconPosition} ${fontSize} ${
                        includeAnimation ? 'animated' : ''
                    }`}
                />
            )}
        </button>
    );
};

export default ActionButton;
